import React from 'react';
import PropTypes from 'prop-types';

import { Spacer, TextButton } from '@zillow/constellation';

// Styled Components
import { StyledTourCardSelectableControls } from './StyledComponents';

const propTypes = {
    isSelected: PropTypes.bool.isRequired,
    onView: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};

const TourCardSelectableControls = ({
    isSelected,
    onView,
    onSelect,
}) => (
    <StyledTourCardSelectableControls>
        <Spacer marginRight="sm">
            <TextButton onClick={onView}>
            View
            </TextButton>
        </Spacer>
        <Spacer marginRight="sm">
            <TextButton onClick={onSelect}>
                {isSelected ? 'Deselect' : 'Select'}
            </TextButton>
        </Spacer>
    </StyledTourCardSelectableControls>
);

TourCardSelectableControls.propTypes = propTypes;

export default TourCardSelectableControls;
